<template>
  <v-table-wrapper
    :infinite-id="infiniteId"
    :list="list"
    :infinite-loading="infiniteLoading"
    :table-height="tableHeight"
    :with-select="true"
    :only-single-select="!isRoleAdmin"
    class="shows-table"
    v-on="$listeners"
  >
    <template #customColumns>
      <el-table-column
        prop="show_date"
        label="Дата и время"
        sortable="custom"
        class-name="shows-table__cell--date"
        min-width="145"
      >
        <template #default="{row:{showDate, showTime}}"> {{ showDate }} {{ showTime }} </template>
      </el-table-column>
      <el-table-column
        prop="status"
        sortable="custom"
        label="Статус"
        class-name="shows-table__cell--status"
        min-width="145"
      >
        <template #default="{row:{status}}">
          <v-tag-group :value="status" :group="$options.SHOWS_STATUSES_GROUP">
            <template #default="{ color, text }">
              <v-tag :color="color"> {{ text }}</v-tag>
            </template>
          </v-tag-group>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        sortable="custom"
        label="Имя покупателя"
        class-name="shows-table__cell--name"
        min-width="244"
        show-overflow-tooltip
      >
        <template #default="{row:{clientName,account}}">
          <v-button
            v-if="clientName && account && account.id"
            class="shows-table__client-link"
            is-text
            :to="{ name: 'customer-edit', params: { customerId: account.id } }"
            >{{ clientName }}</v-button
          >
          <template v-else>{{ clientName || 'имя не указано' }} </template>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="Телефон" class-name="shows-table__cell--phone" min-width="143">
        <template #default="{row:{clientPhone}}">
          {{ formatPhone(clientPhone) || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="isRoleAdmin"
        prop="agent"
        sortable="custom"
        class-name="shows-table__cell--agent"
        label="Агент"
        min-width="200"
        show-overflow-tooltip
      >
        <template #default="{row:{agent}}">
          <v-agent v-if="agent" :photo="agent.photo" @click.stop>
            {{ agent.name }}
          </v-agent>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="advert" label="Объект" class-name="shows-table__cell--advert" min-width="85">
        <template #default="{row:{advert}}"> <v-adverts-popover :adverts="[advert]"></v-adverts-popover> </template>
      </el-table-column>
      <el-table-column
        prop="advert_category"
        label="Категория"
        class-name="shows-table__cell--adverts-category"
        width="100"
      >
        <template #default="{row:{advert}}">
          {{ (advert && advert.category && advert.category.name) || '-' }}
        </template>
      </el-table-column>
    </template>
  </v-table-wrapper>
</template>

<script>
import VTableWrapper from '@/components/common/VTableWrapper.vue'
import VAgent from '@/components/common/VAgent.vue'
import { mapGetters } from 'vuex'
import { MODULE_SESSION } from '@/store/modules/session/session.types'
import { SHOWS_STATUSES_GROUP } from '@/constants/showsStatuses'
import VTag from '@/components/common/VTag.vue'
import VTagGroup from '@/components/common/VTagGroup.vue'
import { formatPhone } from '@/utils/formatters'
import VButton from '@/components/common/VButton.vue'
import VAdvertsPopover from '@/components/common/VAdvertsPopover.vue'

export default {
  SHOWS_STATUSES_GROUP,

  name: 'ShowsTable',
  components: {
    VAdvertsPopover,
    VButton,
    VTableWrapper,
    VTagGroup,
    VTag,
    VAgent
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableHeight: {
      type: Number,
      default: 500
    },
    infiniteId: {
      type: Number,
      required: true
    },
    infiniteLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isRoleAdmin: `${MODULE_SESSION}/isRoleAdmin`
    })
  },
  methods: { formatPhone }
}
</script>

<style lang="scss">
.shows-table {
  &__client-link {
    color: inherit !important;

    &:hover,
    &:focus {
      color: inherit;
      text-decoration: underline;
    }
  }
}
</style>
